import { computed } from 'vue'
import { rgba } from 'polished'
import { useAppStore } from '@/store'

export function renderColor(alpha = 1) {
  const appStore = useAppStore()
  const primaryColor = computed(() => appStore.colorTheme || '#764ab9')
  const color = computed(() => rgba(primaryColor.value, alpha))
  return color.value
}
